import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PasswordResetPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [repeat, setRepeat] = useState('');
  const [message, setMessage] = useState('');
  const [done, setDone] = useState(false);

  const submit = async event => {
    event.preventDefault();
    if (password !== repeat) return setMessage(t('InvalidTwicePasswordMessage'));
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/reset/password`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ newPassword: password, resetToken: searchParams.get('token') })
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) return setMessage(t(body.message || 'InvalidOrExpiredResetLink'));
    setDone(true);
  };

  return <div style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <div className="dashboard-box" style={{ width: 'min(520px, 92vw)', padding: '32px' }}>
      {done ? <><h2>{t('YourPasswordHasBeenUpdatedSuccessfully')}</h2><Link to="/" className="button full-width margin-top-20">{t('LogIn')}</Link></> : <form onSubmit={submit}>
        <h2 style={{ marginBottom: '24px' }}>{t('EnterANewPassword')}</h2>
        <input className="with-border" type="password" minLength="8" maxLength="20" value={password} onChange={event => setPassword(event.target.value)} placeholder={t('Password')} required />
        <input className="with-border" type="password" minLength="8" maxLength="20" value={repeat} onChange={event => setRepeat(event.target.value)} placeholder={t('RepeatPassword')} required />
        {message && <div className="notification error"><p>{message}</p></div>}
        <button className="button full-width" type="submit">{t('Confirm')}</button>
      </form>}
    </div>
  </div>;
};

export default PasswordResetPage;
